import axios from 'axios'
import { advertizerApiHost } from '../../constants/envs'
import { IScheduledDeliveryRepository, ScheduledDeliveriesQuery } from '../../application/ports/IScheduledDeliveryRepository'
import { ScheduledDeliveryEntity } from '../../domain/entities/ScheduledDelivery'
import { mapApiToEntity } from '../mappers/scheduledDeliveries.mapper'
import { AuthTokenProvider } from '../auth/AuthTokenProvider'

export class ScheduledDeliveriesAxiosRepository implements IScheduledDeliveryRepository {
  constructor(private auth: AuthTokenProvider) {}

  private async authHeaders() {
    const token = await this.auth.getToken()
    if (!token) throw new Error('Unauthenticated')
    return { Authorization: `Bearer ${token}` }
  }

  async list(params: ScheduledDeliveriesQuery): Promise<ScheduledDeliveryEntity[]> {
    const headers = await this.authHeaders()
    const res = await axios.get(advertizerApiHost + '/api/scheduled_deliveries', {
      params,
      headers,
    })
    return (res.data.scheduledDeliveries || []).map(mapApiToEntity)
  }

  async get(uuid: string): Promise<ScheduledDeliveryEntity | null> {
    const headers = await this.authHeaders()
    const res = await axios.get(advertizerApiHost + '/api/scheduled_deliveries/' + uuid, { headers })
    return res.data ? mapApiToEntity(res.data) : null
  }
}
